import { useObtenerGridCuentasBancoDashboard, useBuscarCuentasBancoAutoComplete } from "../../Scripts/Services/banco-dashboard-service.js";
import {
    AutoComplete,
    SelectButton,
    Dropdown,
    addLocale,
    Button,
    Column,
    DataTable,
    Calendar,
    ProgressSpinner,
    FilterMatchMode,
    FilterOperator,
    InputNumber,
    locale,
    Message,
    Row,
    ColumnGroup,
  } from 'primereact';
  import React,{useEffect, useState} from 'react'
  export const GridBanco = () => {
    addLocale("es", {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: [
          "domingo",
          "lunes",
          "martes",
          "mi?rcoles",
          "jueves",
          "viernes",
          "s?bado",
        ],
        dayNamesShort: ["dom", "lun", "mar", "mi?", "jue", "vie", "s?b"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        equals: "Igual a",
        notEquals: "Diferente a",
        lt: "Menor a",
        lte: "Menor o igual a",
        gt: "Mayor a ",
        gte: "Mayor o igual a",
        is: "Is",
        isNot: "Is Not",
        before: "Before",
        after: "After",
        clear: "Limpiar",
        apply: "Aplicar",
        matchAll: "Coincidir todo",
        matchAny: "Coincidir cualquiera",
        addRule: "Agregar condicion",
        removeRule: "Quitar condicion",
      });
    const monedaPredeterminada = window.monedaPredeterminada;
    const colorPrimario = window.colorPrimario;
    const [fechasGrid, setFechasGrid] = React.useState(null);
    // tabla
    const [centros, setTiendas] = React.useState([]);
    const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
    const [filtros, setFiltros] = React.useState(null);
    const [cargandoData, setCargandoGrid] = React.useState(true);
    const [gridWhere, setGridWhere] = React.useState({
      where: {
        EsAscendente: false,
        EsOrdernable: true,
        OrderBy: "Balance",
        IndiceDePagina: 0,
        esFecha: false,
        periodo: periodoGrid,
        CentrosNombreList: centros,
      },
    });
    const { data: cuentaBancoGrid, error: errorCuentaBancoGrid } =
    useObtenerGridCuentasBancoDashboard(gridWhere);
    const [totalRecords, setTotalRecords] = React.useState(0);
    const [lazyState, setlazyState] = React.useState({
      first: 0,
      rows: 10,
      page: 0,
      sortField: "Balance",
      sortOrder: -1,
      filters: filtros,
    });
    const onPage = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          IndiceDePagina: event.page,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onSort = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          EsAscendente: event.sortOrder == 1,
          OrderBy: event.sortField,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onFilter = (event) => {
      const filtros = event.filters;
      setlazyState(event);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          NumeroCuentaList: filtros.NumeroCuenta.value,
          MontoConciliadoFiltros: filtros.MontoConciliado.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          BalanceTranstitoFiltros: filtros.BalanceTranstito.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
          BalanceFiltros: filtros.Balance.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
          TasaAprobadoSolicitudPagoFiltros: filtros.TasaAprobadoSolicitudPago.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
          TasaRechazoSolicitudPagoFiltros: filtros.TasaRechazoSolicitudPago.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
          TasaRechazoChequesFiltros: filtros.TasaRechazoCheques.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    };
    const borrarFiltros = () => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          BalanceTranstitoFiltros: null,
          BalanceFiltros: null,
          TasaAprobadoSolicitudPagoFiltros: null,
          TasaRechazoSolicitudPagoFiltros: null,
          MontoConciliadoFiltros: null,
          NumeroCuentaList: null,
          TasaRechazoChequesFiltros: null
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
      initFiltros();
    };
    const initFiltros = () => {
      setFiltros({
        Balance: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        MontoConciliado: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        BalanceTranstito: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TasaAprobadoSolicitudPago: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TasaRechazoSolicitudPago: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TasaRechazoCheques: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        NumeroCuenta: {
          value: null,
          matchMode: FilterMatchMode.IN,
        },
      });
    };
      const formatearBalance = (rowData) => {
        return formatearCantidad(rowData.Balance);
      };
      const formatearMontoConciliado = (rowData) => {
        return formatearCantidad(rowData.MontoConciliado);
      };
      const formatearBalanceEnTransito = (rowData) => {
        return formatearCantidad(rowData.BalanceTranstito);
      };
      const formatearTasaAprobadoSolicitudPago = (rowData) => {
        return formatearTasa(rowData.TasaAprobadoSolicitudPago);
      };
      const formatearTasaRechazoSolicitudPago = (rowData) => {
        return formatearTasa(rowData.TasaRechazoSolicitudPago);
      };
      const formatearTasaRechazoCheques = (rowData) => {
        return formatearTasa(rowData.TasaRechazoCheques);
      };
    const formatearTasa = (value) => {
        value = value ?? 0.00;
        return `${value.toFixed(2)}%`;
      };
    const formatearCantidad = (value) => {
        value = value ?? 0.00;
        return `${Citrus.Convert.toCurrencyNoSimbolo(value)}`;
      };
    const tasasFiltroTemplate = (options) => {
      return (
        <InputNumber
          value={options.value}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          suffix="%"
        />
      );
    };
    const montosFiltroTemplate = (options) => {
      return (
        <InputNumber
          value={options.value}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          locale="en-US" minFractionDigits={2}
        />
      );
    };
    const CuentasBancoFiltroTemplate = (options) => {
      return (
        <AutoComplete
          pt={{
            panel: { style: { width: "400px" } },
          }}
          onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
          ref={autoCompleteRef}
          emptyMessage="No hay resultados disponibles"
          showEmptyMessage="true"
          inputId="ac"
          value={options.value}
          multiple
          suggestions={dataFiltrada}
          completeMethod={buscarCuentasBanco}
          placeholder="Buscar Cuentas de Banco"
          onChange={(e) => options.filterCallback(e.value)}
          style={{ width: "400px" }}
        />
      );
    };
    //multiLookup
    const autoCompleteRef = React.useRef(null);
    const [where, setWhere] = React.useState({ where: {} });
    const { data } = useBuscarCuentasBancoAutoComplete(where);
    const [dataFiltrada, setDataFiltrada] = React.useState(null);
    const [cargando, setCargando] = React.useState(true);
    const buscarCuentasBanco = (event) => {
      setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
    };
  
    //filtro periodos
    const [periodo, setPeriodo] = React.useState(1);
    const periodos = [
      { name: "Actual", value: 1 },
      { name: "Anterior", value: 2 },
      { name: "Otro", value: 3 },
    ];
    const [value, setValue] = React.useState(3);
    const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
    const actual = [
      { name: "Hoy", value: 1 },
      { name: "Esta Semana", value: 2 },
      { name: "Este Mes", value: 3 },
      { name: "Este Trimestre", value: 4 },
      { name: "Este Año", value: 5 },
    ];
    const anterior = [
      { name: "Ayer", value: 6 },
      { name: "Semana Anterior", value: 7 },
      { name: "Mes Anterior", value: 8 },
      { name: "Trimestre Anterior", value: 9 },
      { name: "Año Anterior", value: 10 },
    ];
    function handleChange(value) {
      setValue(value);
      setCargandoGrid(true);
      let periodo;
      switch (value) {
        case 1:
          periodo = "diario";
          break;
        case 2:
          periodo = "semanal";
          break;
        case 3:
          periodo = "mensual";
          break;
        case 4:
          periodo = "trimestral";
          break;
        case 5:
          periodo = "anual";
          break;
        case 6:
          periodo = "ayer";
          break;
        case 7:
          periodo = "semana anterior";
          break;
        case 8:
          periodo = "mes anterior";
          break;
        case 9:
          periodo = "trimestre anterior";
          break;
        case 10:
          periodo = "ano anterior";
          break;
      }
      setPeriodoGrid(periodo);
      const newWhere = {
        where: {
          ...gridWhere.where,
          periodo: periodo,
          esFecha: false,
        },
      };
      setGridWhere(newWhere);
    }
    const [dates, setDates] = React.useState(null);
    let today = new Date();
    const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);
  
    function setFechas() {
      setValue(null);
      const fechasFormateadas = dates.map((date) => formatDate(date));
      setFechasGrid(fechasFormateadas);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: formatDate(dates[0]),
          fechaFin: formatDate(dates[1]),
          esFecha: true,
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    }
    function formatDate(date) {
      var date = new Date(date);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      return day + "/" + month + "/" + year;
    }
    const matchModes = [
      {
        label: "Mayor o igual a",
        value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      },
      { label: "Menor o igual a", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    const header = () => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="p-component">
            <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Limpiar Filtros"
              outlined
              onClick={borrarFiltros}
              id="quitarFiltros"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "50%",
            }}
          >
            <div style={{ width: "40%", marginBottom: "5px" }}>
              <Dropdown
                value={periodo}
                onChange={(e) => setPeriodo(e.value)}
                options={periodos}
                optionLabel="name"
              />
            </div>
  
            {verRangoDeFechas ? (
              <div>
                <Calendar
                  maxDate={today}
                  placeholder="Rango de Fechas"
                  dateFormat="dd/mm/yy"
                  value={dates}
                  selectionMode="range"
                  locale="es"
                  onChange={(e) => setDates(e.value)}
                />
              </div>
            ) : (
              <SelectButton
                value={value}
                onChange={(e) => handleChange(e.value)}
                optionLabel="name"
                options={periodosPredifinidos}
              />
            )}
          </div>
        </div>
      );
    };
    const colmunas = [
      {
        field: "Simbolo",
        header: "Simbolo",
        dataType: "string",
      },
      {
        field: "Balance",
        header: "Balance",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearBalance
      },
      {
        field: "MontoConciliado",
        header: "Monto Conciliado",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearMontoConciliado
      },
      {
        field: "BalanceTranstito",
        header: "Balance en Transito",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearBalanceEnTransito
      },
      {
        field: "TasaAprobadoSolicitudPago",
        header: "Tasa de solicitudes de pago aprobadas",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTasaAprobadoSolicitudPago
      },
      {
        field: "TasaRechazoSolicitudPago",
        header: "Tasa de solicitudes de pago rechazadas",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTasaRechazoSolicitudPago
      },
      {
        field: "TasaRechazoCheques",
        header: "Tasa de cheques rechazados",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTasaRechazoCheques
      },
    ];
    // useEffect
    React.useEffect(() => {
      locale("es");
      initFiltros();
    }, []);
    React.useEffect(() => {
      if (data) {
        let _centrosFiltrados = [];
        _centrosFiltrados = data.Resultados.map((e) => {
          return e.text;
        });
        setDataFiltrada(_centrosFiltrados);
      }
    }, [data]);
    React.useEffect(() => {
      if (cuentaBancoGrid && !errorCuentaBancoGrid) {
        setTotalRecords(cuentaBancoGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      } else if (cuentaBancoGrid) {
        setTotalRecords(cuentaBancoGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      }
      setCargandoGrid(false);

    }, [cuentaBancoGrid]);
    React.useEffect(() => {
      if (dates) {
        if (dates[0] !== null && dates[1] !== null) {
          setFechas();
        }
      }
    }, [dates]);
    React.useEffect(() => {
      if (periodo == 1) {
        setPeriodosPredifinidos(actual);
        setVerRangoDeFechas(false);
      } else if (periodo == 2) {
        setPeriodosPredifinidos(anterior);
        setVerRangoDeFechas(false);
      } else {
        setVerRangoDeFechas(true);
      }
    }, [periodo]);
    React.useEffect(() => {
      setlazyState({
        ...lazyState,
        filters: filtros,
      });
    }, [filtros]);
  
    return (
      <div className="new-p-table">
        {cargando ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProgressSpinner />
          </div>
        ) : (
          <>
            <div>
              {errorCuentaBancoGrid && (
                <Message
                  severity="warn"
                  text={errorCuentaBancoGrid?.Mensaje}
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              )}
            </div>
            <DataTable
              showGridlines
              header={header}
              onFilter={onFilter}
              filters={lazyState.filters}
              value={cuentaBancoGrid.centros}
              lazy
              first={lazyState.first}
              rows={25}
              loading={cargandoData}
              paginator
              totalRecords={totalRecords}
              onPage={onPage}
              onSort={onSort}
              sortField={lazyState.sortField}
              sortOrder={lazyState.sortOrder}
              tableStyle={{ minWidth: "50rem" }}
              stripedRows
              size="small"
              emptyMessage="No hay resultados disponibles."
              resizableColumns
              columnResizeMode="expand"
              pt={{
                paginator: {
                  pageButton: "p-component",
                  nextPageButton: "p-component",
                  lastPageButton: "p-component",
                  prevPageButton: "p-component",
                  firstPageButton: "p-component",
                },
              }}
            >
          <Column
            style={{ textAlign: "right" }}
            sortable
            field="IdSec"
            header="ID"
          />
          <Column
            style={{ minWidth: "15rem" }}
            sortable
            field="NumeroCuenta"
            header="Numero de Cuenta"
            showFilterMatchModes={false}
            filter
            filterField="NumeroCuenta"
            filterElement={CuentasBancoFiltroTemplate}
            pt={{
              filterMenuButton: { className: "p-component" },
              filterButtonbar: { className: "test" },
            }}
          />
          {colmunas.map((col, i) => (
            <Column
              style={{ minWidth: "5rem", textAlign: col.field == "Simbolo" ? 'left' : 'right' }}
              pt={{
                filterMenuButton: { className: "p-component" },
                filterButtonbar: { className: "test" },
              }}
              sortable
              field={col.field}
              header={col.header}
              body={col.body}
              filter
              sortField={col.field}
              filterField={col.field}
              filterElement={col.filterElement}
              dataType={col.dataType}
              showFilterOperator={false}
              filterMatchModeOptions={matchModes}
            />
          ))}
            </DataTable>
          </>
        )}
      </div>
    );
  };
